<template>
  <div class="list-item-line estimate-details-body-content">
    <div class="list-item-line-group flex-column align-items-stretch">
      <base-input :label="`${$t('ESTIMATES.COMPONENTS_ESTIMATOR')}`" group>
        <input
          :placeholder="$t('ESTIMATES.COMPONENTS_ESTIMATOR')"
          :name="$t('ESTIMATES.COMPONENTS_ESTIMATOR')"
          :value="$objectDenomination(estimate?.startedComponentsBy)"
          readonly
          class="form-control"
          :class="{
            'bg-transparent border-right-0':
              canChangeComponentsEstimateManager(estimate),
          }"
        />
        <div
          class="input-group-append"
          v-if="canChangeComponentsEstimateManager(estimate)"
        >
          <button
            class="btn border border-left-0 border-light shadow-none rounded-right"
            @click="showChangeComponentsEstimateManagerModal = true"
          >
            <img src="/img/change-user.svg" alt="estimation in progress" />
          </button>
        </div>
      </base-input>
    </div>
    <div class="list-item-line-group flex-column align-items-stretch">
      <base-input :label="`${$t('ESTIMATES.TIMES_ESTIMATOR')}`" group>
        <input
          :placeholder="$t('ESTIMATES.TIMES_ESTIMATOR')"
          :name="$t('ESTIMATES.TIMES_ESTIMATOR')"
          :value="$objectDenomination(estimate?.startedTimesBy)"
          readonly
          class="form-control"
          :class="{
            'bg-transparent border-right-0':
              canChangeTimesEstimateManager(estimate),
          }"
        />
        <div
          class="input-group-append"
          v-if="canChangeTimesEstimateManager(estimate)"
        >
          <button
            class="btn border border-left-0 border-light shadow-none rounded-right"
            @click="showChangeTimesEstimateManagerModal = true"
          >
            <img src="/img/change-user.svg" alt="estimation in progress" />
          </button>
        </div>
      </base-input>
    </div>
    <div class="list-item-line-group flex-column align-items-stretch">
      <base-input
        :label="`${$t('COMMON.APPROVER')}`"
        :placeholder="$t('COMMON.APPROVER')"
        :name="$t('COMMON.APPROVER')"
        :value="$objectDenomination(estimate?.startedApproveBy)"
        readonly
      />
    </div>
    <user-selector-modal
      v-if="canChangeComponentsEstimateManager(estimate)"
      :filter-organization="estimate.organization?.id"
      :filter-permission="$permissions.PERM_EDIT_ESTIMATIONS_COMPONENTS"
      :header-text="$t('ESTIMATES.CHANGE_COMPONENTS_MANAGER')"
      :loading="loading"
      :open.sync="showChangeComponentsEstimateManagerModal"
      :search-text="$t('COMMON.SEARCH_MANAGER')"
      :confirm-action="changeComponentsEstimateManager"
      :user.sync="componentsNewManager"
    />
    <user-selector-modal
      v-if="canChangeTimesEstimateManager(estimate)"
      :filter-organization="estimate.organization?.id"
      :filter-permission="$permissions.PERM_EDIT_ESTIMATIONS_TIMES"
      :header-text="$t('ESTIMATES.CHANGE_TIMES_MANAGER')"
      :loading="loading"
      :open.sync="showChangeTimesEstimateManagerModal"
      :search-text="$t('COMMON.SEARCH_MANAGER')"
      :confirm-action="changeTimesEstimateManager"
      :user.sync="timesNewManager"
    />
  </div>
</template>

<script>
import UserSelectorModal from "@/components/UserSelectorModal.vue";
import estimatePermissionsMixin from "@/mixins/estimate-permissions-mixin";

export default {
  name: "estimate-view-estimate-managers",

  components: {
    UserSelectorModal,
  },

  mixins: [estimatePermissionsMixin],

  props: {
    estimate: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    const componentsNewManager = this.estimate.startedComponentsBy?.id;
    const timesNewManager = this.estimate.startedTimesBy?.id;
    return {
      componentsNewManager,
      showChangeComponentsEstimateManagerModal: false,
      timesNewManager,
      showChangeTimesEstimateManagerModal: false,
    };
  },

  methods: {
    changeComponentsEstimateManager() {
      this.$emit("onChangeComponentsEstimateManager", {
        estimationId: this.estimate.id,
        data: { user_id: this.componentsNewManager },
      });
    },
    changeTimesEstimateManager() {
      this.$emit("onChangeTimesEstimateManager", {
        estimationId: this.estimate.id,
        data: { user_id: this.timesNewManager },
      });
    },
  },

  watch: {
    showChangeComponentsEstimateManagerModal(value) {
      if (!value) {
        this.componentsNewManager = this.estimate.startedComponentsBy?.id;
      }
    },
    showChangeTimesEstimateManagerModal(value) {
      if (!value) {
        this.timesNewManager = this.estimate.startedTimesBy?.id;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
